"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attestation = void 0;
const zod_1 = require("zod");
const public_key_hex_string_1 = require("../public-key-hex-string");
const claimable_1 = require("./claimable");
const timestamp_1 = require("./timestamp");
/**
 * Represents an attestation for a user in a web3 environment.
 *
 * An attestation is a verifiable claim about a user's attribute or action,
 * typically recorded on a blockchain for transparency and security.
 *
 * inspiration:
 * https://docs.attest.org/docs/idea--zone/use--case--examples/credentials
 * https://github.com/ethereum-attestation-service/eas-contracts/blob/master/contracts/IEAS.sol
 */
exports.Attestation = zod_1.z.object({
    // TODO: consider adding UID (a la EAS), and sparing the nonce.
    /**
     * The time, in milliseconds since the Unix epoch, at which the credential was issued (issuer time).
     */
    createdAt: timestamp_1.Timestamp,
    /**
     * The key of the entity issues the credential.
     */
    issuerKey: public_key_hex_string_1.PublicKeyHexString,
    /**
     * The key of the entity to whom the credential is given.
     */
    recipientKey: public_key_hex_string_1.PublicKeyHexString,
    /**
     * Signature that ensures the attestation has not been tampered with and can be verified using the issuer's key.
     */
    signature: zod_1.z.string(),
    /**
     * EIP-191 signature for on-chain verification on Ethereum-like networks.
     */
    eip191Signature: zod_1.z.string(), // TODO: Consider using single signature.
    /**
     * The actual claimable information of the credential.
     */
    data: claimable_1.Claimable,
    /**
     * A unique value to prevent replay attacks.
     */
    nonce: zod_1.z.string(),
    // TODO: additional fields - expiration, zk-proof and more.
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXR0ZXN0YXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZW50aXRpZXMvYXR0ZXN0YXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXVCO0FBRXZCLG9FQUE2RDtBQUM3RCwyQ0FBc0Q7QUFDdEQsMkNBQXVDO0FBRXZDOzs7Ozs7Ozs7R0FTRztBQUNVLFFBQUEsV0FBVyxHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQUM7SUFDbEMsK0RBQStEO0lBRS9EOztPQUVHO0lBQ0gsU0FBUyxFQUFFLHFCQUFTO0lBQ3BCOztPQUVHO0lBQ0gsU0FBUyxFQUFFLDBDQUFrQjtJQUM3Qjs7T0FFRztJQUNILFlBQVksRUFBRSwwQ0FBa0I7SUFDaEM7O09BRUc7SUFDSCxTQUFTLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtJQUNyQjs7T0FFRztJQUNILGVBQWUsRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUseUNBQXlDO0lBQ3RFOztPQUVHO0lBQ0gsSUFBSSxFQUFFLHFCQUFTO0lBQ2Y7O09BRUc7SUFDSCxLQUFLLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtJQUVqQiwyREFBMkQ7Q0FDNUQsQ0FBQyxDQUFBIn0=